import { defineComponent as _defineComponent } from 'vue'
import ConfirmDeleteModal from "@/components/ui/modals/ConfirmDeleteModal.vue";
  import InputSearch from "@/components/ui/input/InputSearch.vue";
  import { onMounted, ref, watch } from "vue";
  import router from "@/router";
  import store from "@/store";
  import { UserInterface } from "@/types/UserInterface";
  import { EstateInterface } from "@/types/EstateInterface";
  import { getFirstLastName } from "@/helpers/user";
  import { debounce } from "@/helpers/debounce";
  import { useToast } from "vue-toastification";
  import { showResponseErrorMessage } from "@/helpers/showResponseErrorMessage";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'AdminUser',
  setup(__props, { expose: __expose }) {
  __expose();

  const toast = useToast();
  const userId = router.currentRoute.value.params.userId;
  const estates = ref<EstateInterface[]>([]);
  const user = ref<UserInterface | null>(null);
  const searchQuery = ref("");
  const showConfirmDeleteModal = ref(false);
  const itemForDelete = ref({ id: "", title: "" });

  watch(
    () => searchQuery.value,
    () => {
      debounceSearch();
    }
  );

  onMounted(() => {
    fetchUser();
    getEstates();
  });

  const fetchUser = () => {
    store.dispatch("user/getUser", userId).then((res) => {
      user.value = res.data;
    });
  };

  const getEstates = () => {
    store
      .dispatch("estate/getEstates", {
        landownerId: userId,
        title: searchQuery.value,
      })
      .then((res) => {
        estates.value = filterEstatesByLandownerId(res.data);
      });
  };

  const filterEstatesByLandownerId = (estates: EstateInterface[]) => {
    return estates.filter((estate) => estate.landownerId._id === userId);
  };

  const debounceSearch = debounce(getEstates);

  const toEstate = (id: string) => {
    const currentEstate = estates.value.find((estate) => estate._id === id);
    const landownerId = currentEstate?.landownerId._id;

    router.push({
      name: "AdminEstate",
      params: { userId: landownerId, estateId: id },
    });
  };

  const toCreateEstate = () => {
    router.push({
      name: "AdminEstateCreate",
    });
  };

  const toEditUserDetails = () => {
    router.push({
      name: "AdminLandownerDetailsUpdate",
      params: { userId },
    });
  };

  const toEditUser = () => {
    router.push({
      name: "AdminUserUpdate",
      params: { userId },
    });
  };

  const deleteEstate = (id: string) => {
    store
      .dispatch("estate/deleteEstate", id)
      .then(() => {
        getEstates();
        toast.success("The estate was successfully deleted");
      })
      .catch((error) => {
        showResponseErrorMessage(error);
      });
  };

  const setItemForDelete = (estate: EstateInterface) => {
    itemForDelete.value = { id: estate._id, title: estate.title };
    showConfirmDeleteModal.value = true;
  };

  const getEstateType = (estate: EstateInterface) => {
    // Determine estate type based on available data
    return estate.type || "-";
  };

  const getAddOns = (estate: EstateInterface) => {
    // Return add-ons/packages for the estate
    return estate.addons && estate.addons.length > 0
      ? estate.addons.join(", ")
      : "-";
  };

const __returned__ = { toast, userId, estates, user, searchQuery, showConfirmDeleteModal, itemForDelete, fetchUser, getEstates, filterEstatesByLandownerId, debounceSearch, toEstate, toCreateEstate, toEditUserDetails, toEditUser, deleteEstate, setItemForDelete, getEstateType, getAddOns, ConfirmDeleteModal, InputSearch, onMounted, ref, watch, get router() { return router }, get store() { return store }, get UserInterface() { return UserInterface }, get EstateInterface() { return EstateInterface }, get getFirstLastName() { return getFirstLastName }, get debounce() { return debounce }, get useToast() { return useToast }, get showResponseErrorMessage() { return showResponseErrorMessage } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})